<template>
  <div class="daily">
    <div class="dailyStatus2"></div>
    <div class="dailyStatus">
        <div class="icon"></div>
        <div class="datetime">{{toDate(date)}}<br>星期{{wdy[moment(date).weekday()]}}</div>
        <div class="box"><slot></slot></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['date', 'wdy']

}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.box {
  overflow-y: auto;
  max-height: calc(100% - 120px);
}
.daily {
  position: relative;
  z-index: 1;
  height: calc(100% - 45px);
  flex: 1;
}
.datetime {
  width: 100%;
  color: var(--color-checked);
  position: relative;
  z-index: 5;
  padding-top: 47px;
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 35px;
  text-align: center;
  letter-spacing: 0.1em;
}
.icon {
  width: 71px;
  height: 71px;
  background-image: url(/celender.svg);
  border-radius: 50%;
  background-color: var(--color-checked);
  z-index: 5;
  position: absolute;
  top: -35.5px;
  left: 50%;
  transform: translateX(-50%);
}
.dailyStatus2 {
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin-top: 45px;
  width: 380px;
  height: calc(100% - 45px);
  border-radius: 10px;
  background-color: transparent;
  &::before {
    content: '';
    width: 90px;
    height: 90px;
    display: inline-flex;
    position: absolute;
    top: -90px;
    left: 50%;
    background-color: transparent;
    z-index: -1;
    transform: translateX(-50%);
    border-radius: 50%;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  }

  &::after {
    content: '';
    position: absolute;
    top: -45px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: transparent;
    border-radius: 10px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
    z-index: -1;
  }
}
.dailyStatus {
  z-index: 3;
  margin-top: 45px;
  width: 380px;
  height: calc(100%);
  z-index: 3;
  position: relative;
  border-radius: 10px;
  &::before {
    content: '';
    width: 90px;
    height: 90px;
    display: inline-flex;
    position: absolute;
    top: -45px;
    left: 50%;
    background-color: #FFFFFF;
    z-index: 2;
    transform: translateX(-50%);
    border-radius: 50%;

  }
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #FFFFFF;
    border-radius: 10px;
    z-index: -1;
  }
}
</style>
